import NoData from "@/components/NoData";
import LtdLoading from "@/components/LichThiDauFull/LtdLoading";
import CountryLeagueFilter from "@/components/LichThiDauByCountry/CountryLeagueFilter";
import LeagueStandingTotal from "@/components/BangXepHangByLeague/LeagueStandingTotal";
import useBangXepHangByCountry from "./useBangXepHangByCountry";
import "@/components/LichThiDauFull/index.css";
import "@/components/BangXepHangByLeague/index.css";

/**
 * @param {object} props
 * @param {string} props.country
 */
export default function BangXepHangByCountry({ country: countrySlug }) {
  const {
    themeStyle,
    leagues,
    selectedId,
    setSelectedId,
    leaguesWithContent,
    standingsMap,
    waiting,
    failed,
    countryLoading,
  } = useBangXepHangByCountry(countrySlug);

  return (
    <div
      className="kbv-bxh kbv-ltd-full flex flex-col gap-2 bg-[var(--theme-bg)] text-[var(--theme-text)]"
      style={themeStyle}
    >
      <div className="kbv-ltd-filter-block">
        <CountryLeagueFilter
          leagues={leagues}
          selectedId={selectedId}
          onSelect={setSelectedId}
          themeStyle={themeStyle}
          loading={countryLoading}
        />
      </div>
      <div className="kbv-bycountry-scroll">
        {failed ? (
          <NoData message="Không có bảng xếp hạng" />
        ) : waiting ? (
          <LtdLoading />
        ) : leaguesWithContent.length === 0 ? (
          <NoData message="Không có bảng xếp hạng" />
        ) : (
          <div className="flex flex-col gap-4">
            {leaguesWithContent.map((league) => (
              <div key={league.id} className="flex flex-col gap-2">
                <div className="kbv-ltd-league-head">
                  <div className="flex min-w-0 flex-1 items-center gap-1 px-2 py-2">
                    {league?.logo ? (
                      <img
                        src={league.logo}
                        alt=""
                        className="w-5 h-5 object-contain shrink-0"
                        width={20}
                        height={20}
                      />
                    ) : null}
                    <span className="truncate text-sm font-semibold text-[var(--theme-text)]">
                      {league?.nameVN || league?.name || ""}
                    </span>
                  </div>
                </div>
                <LeagueStandingTotal
                  league={league}
                  standingsRes={standingsMap[String(league.id)]}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
